//https://blog.csdn.net/weixin_42681295/article/details/113626510
//1->common.js中引入axios

import Axios from 'axios'
Axios.defaults.timeout = 5 * 1000
// Axios.interceptors.request.use(
//     config => {
//         console.log("网络拦截request----------", config)

//         // 判断网络状态
//         if (!navigator.onLine) {
//             console.log("网络拦截request----------navigator.onLine") // for debug
//             ElMessage.warning({
//                 message: '服务器内部错误，请稍后重试',
//                 duration: 3000, // 持续时间
//                 center: true, // 是否居中显示
//                 // 自定义样式
//                 customClass: 'custom-warning-message',
//                 // 自定义样式对象
//                 style: {
//                     width: '400px', // 设置宽度
//                     height: '100px', // 设置高度
//                     fontSize: '36px',
//                 }
//             });
//             return
//         }
//         return config
//     },
//     error => {
//         // do something with request error
//         console.log("网络拦截request----------error", error) // for debug
//         return Promise.reject(error)
//     }
// )

// Axios.interceptors.response.use(
//     response => {



//         const res = response.data
//         console.log('网络拦截response----------' + JSON.stringify(res))

//     },
//     error => {
//         if (!navigator.onLine) {
//             console.log("网络拦截response----------navigator.onLine") // for debug

//             return
//         }
//         console.log('网络拦截response----------error' + Promise.reject(error)) // for debug
//         return Promise.reject(error)
//     }
// )




//2->对get请求传递过来的参数处理
function paramsToUrl(url, params) {
    if (!params) return url
    for (var key in params) {
        if (params[key] && params[key] != 'undefined') {
            if (url.indexOf('?') != -1) {
                url += '&' + '' + key + '=' + params[key] || '' + ''
            } else {
                url += '?' + '' + key + '=' + params[key] || '' + ''
            }
        }
    }
    return url
}

//3->在common.js中封装公用方法-----封装请求的方法
function requireData(url, params, type, item) {
    if (!url) return false
    switch (item) {
        case 'M1':
            url = Axios.defaults.baseM1URL + url
            break;
        case 'M2':
            url = Axios.defaults.baseM2URL + url
            break;
        case 'M3':
            url = Axios.defaults.baseM3URL + url
            break;
        default:
            url = Axios.defaults.baseM1URL + url
    }
    if (type === 'get') {
        url = paramsToUrl(url, params)
        return new Promise((resolve, reject) => {
            Axios.get(url, params).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    } else {
        return new Promise((resolve, reject) => {
            Axios.post(url, params).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
}

const common = {
    //->接口1的请求数据方法
    reqM1Service(url, params, type) {
        return requireData(url, params, type, 'M1')
    },
    //->接口2的请求数据方法
    reqM2Service(url, params, type) {
        return requireData(url, params, type, 'M2')
    },
    //->接口3的请求数据方法
    reqM3Service(url, params, type) {
        return requireData(url, params, type, 'M3')
    }
}

export default common

